import { EvtSelect } from "components/select";
import { getDirectusField } from "directus/src/operations";
import { useFetch } from "hooks/src/useFetch";
import React from "react";

const SelectPriority = ({
  collection,
  className,
  value,
  onChange,
  placeholder,
  ...props
}) => {
  const { data, isLoading, isError } = useFetch({
    queryKey: [collection, "priority"],
    queryFn: async () => {
        const response = await getDirectusField(collection, "priority");

        const data = response.meta.options.choices.map((priority) => {
            return { name: priority.text, id: priority.value };
      });

      return data;
    },
    enabled: !!collection,
  });

  return (
    <EvtSelect
      data={data}
      isLoading={isLoading}
      className={className}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      type="filter"
      {...props}
    />
  );
};

export default SelectPriority;
